/** Unsigned session hint for edge/proxy gating. This cookie is not authorization. */
export const clientSessionHintCookieName = "tr-client-session-hint";

const cookieStorePath = "/";
const cookieStoreMaxAgeSeconds = 2_592_000;

const getBrowserCookieStore = (): CookieStore | null => {
  if (!("window" in globalThis)) {
    return null;
  }
  const { cookieStore } = window;
  return cookieStore ?? null;
};

export async function setClientSessionHintCookie(): Promise<void> {
  const cookieStore = getBrowserCookieStore();
  if (cookieStore === null) {
    return;
  }
  await cookieStore.set({
    expires: Date.now() + cookieStoreMaxAgeSeconds * 1000,
    name: clientSessionHintCookieName,
    path: cookieStorePath,
    sameSite: "lax",
    value: "1",
  });
}

export function clearClientSessionHintCookie(): void {
  const cookieStore = getBrowserCookieStore();
  if (cookieStore === null) {
    return;
  }
  void cookieStore.delete({
    name: clientSessionHintCookieName,
    path: cookieStorePath,
  });
}
